import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
	isLoggedIn: boolean;
	accessToken: string | null;
	refreshToken: string | null;
	impersonationToken: string | null;
	email: string | null;
}

interface AuthActions {
	logout: () => void;
	login: (accessToken: string, refreshToken?: string, email?: string) => void;
	setImpersonationToken: (impersonationToken: string | null) => void;
	setEmail: (email: string | null) => void;
}

const initialState: AuthState = {
	isLoggedIn: false,
	accessToken: null,
	refreshToken: null,
	impersonationToken: null,
	email: null,
};

export const useAuthStore = create<AuthState & AuthActions>()(
	persist(
		(set) => ({
			...initialState,
			logout: () => {
				set({
					accessToken: null,
					isLoggedIn: false,
					refreshToken: null,
					impersonationToken: null,
					email: null,
				});
			},
			login: (accessToken: string, refreshToken?: string, email?: string) => {
				set({
					accessToken,
					isLoggedIn: true,
					refreshToken: refreshToken || null,
					email: email || null,
				});
			},
			setImpersonationToken: (impersonationToken: string | null) => {
				set({ impersonationToken });
			},
			setEmail: (email: string | null) => {
				set({ email });
			},
		}),
		{ name: "auth" },
	),
);
